import { CopyOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, message, Space, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
// import { useSetRecoilState } from "recoil";
import {
  apiCompaniesList,
  apiDeleteOrganization,
  apiGenerateTokenForUsersApi,
} from "../../../api/api";
import { CompanyType } from "../../../types";
import { EditRowButton } from "../../base/button";
import { ModalAddNewCompany } from "./modalForms/addCompany";
import { ModalEditCompany } from "./modalForms/editCompany";
import { addNewCompanyModal, currentEditCompany } from "./state";
// import { ModalGenerateToken } from "./modalForms/generateToken";
// import { generateTokenModal } from "./state";

const copyToken = async (inn: string) => {
  const resp = await apiGenerateTokenForUsersApi(inn);
  if (resp.token) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(resp.token);
    }
    const textArea = document.createElement("textarea");
    textArea.value = resp.token;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-unused-expressions
      document.execCommand("copy") ? resolve("success") : reject();
      textArea.remove();
    });
  }
  return undefined;
};

export const CompaniesTable = () => {
  const [dataSource, setDataSource] = useState<CompanyType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  // const setVisibleTokenModal = useSetRecoilState(generateTokenModal);
  const setVisibleNewCompany = useSetRecoilState(addNewCompanyModal);
  const getCompanies = async () => {
    setLoading(true);
    const resp = await apiCompaniesList();
    setDataSource(resp.result);
    setLoading(false);
  };

  const columnsTableCompanies: ColumnsType<CompanyType> = [
    {
      title: "ИНН",
      dataIndex: "inn",
    },
    {
      title: "Название организации",
      dataIndex: "companyName",
    },
    {
      title: "Логин",
      dataIndex: "login",
    },
    {
      title: "Действия",
      render: (row: CompanyType) => (
        <>
          <Space>
            <EditRowButton row={row} recoilState={currentEditCompany} />
            <Button
              icon={<CopyOutlined />}
              onClick={() => {
                copyToken(row.inn).then(() =>
                  message.success("Токен скопирован")
                );
              }}
            />
            <Button
              icon={<DeleteOutlined />}
              onClick={() => {
                apiDeleteOrganization(row.inn).then(() => {
                  setDataSource(dataSource.filter((el) => el.inn !== row.inn));
                  message.success("Организация удалена");
                });
              }}
            />
          </Space>
        </>
      ),
    },
  ];

  useEffect(() => {
    getCompanies();
  }, []);

  return (
    <>
      <h1 style={{ float: "left", margin: "10px 20px 0px" }}>Организации</h1>
      {/* <div style={{ float: "right", margin: "10px 20px 0px" }}>
        <Space> */}
      {/* <Button type="primary" onClick={() => setVisibleTokenModal(true)}>
            Создать токен
          </Button> */}
      <Button
        type="primary"
        icon={<PlusOutlined />}
        style={{ marginTop: 10, marginRight: 20, float: "right" }}
        onClick={() => {
          setVisibleNewCompany(true);
        }}
      >
        Добавить организацию
      </Button>
      {/* </Space>
      </div> */}
      <div style={{ clear: "both" }} />
      <Table
        style={{ margin: 20, marginTop: 10 }}
        loading={loading}
        scroll={{ y: "calc(100vh - 244px" }}
        dataSource={dataSource}
        columns={columnsTableCompanies}
      />
      <ModalAddNewCompany
        modalState={addNewCompanyModal}
        updateDataSource={setDataSource}
      />
      <ModalEditCompany
        modalState={currentEditCompany}
        updateDataSource={setDataSource}
      />
      {/* <ModalGenerateToken modalState={generateTokenModal} /> */}
    </>
  );
};
